"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxPasswordField;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _VisibilityOffIcon, _VisibilityIcon;
var _excluded = ["id", "InputProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ReduxPasswordField(_ref) {
  var id = _ref.id,
    InputProps = _ref.InputProps,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
    id: id,
    InputProps: (0, _extends2.default)({
      endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        "aria-label": "Toggle password visibility",
        id: "".concat(id, "ToggleVisibilityButton"),
        onClick: function onClick() {
          return setShowPassword(!showPassword);
        },
        size: "large"
      }, showPassword ? _VisibilityOffIcon || (_VisibilityOffIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.VisibilityOff, null)) : _VisibilityIcon || (_VisibilityIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Visibility, null))))
    }, InputProps),
    type: showPassword ? 'text' : 'password'
  }, props));
}